import React from 'react'

export const PageContainer = ({ children }) => {
  return (
    <div>
      <main id="main">{children}</main>
    </div>
  )
}
